import { Link } from "@/i18n/routing"

import IconLogo from "./IconLogo"

export default function SpectraLogo({ className, logoSize }: { className?: string; logoSize: number }) {
  return (
    <Link href="/">
      <h1 className={`flex font-glacialIndifference text-2xl tracking-[5px] ${className}`}>
        spectr
        <IconLogo className="translate-y-1.5" style={{ height: logoSize, width: logoSize }} />
      </h1>
    </Link>
  )
}
